var React = require('react');

function BlogArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.204.961l.007.993a638.6 638.6 0 01.01 5.303l-.006 2.107-.003.85-1-.004-1-.004.003-.85a1273.568 1273.568 0 00.006-4.815 433.084 433.084 0 01-5.925 6.349l-.176.184L.674 9.693l.174-.183.494-.52a434.076 434.076 0 005.612-6.028H1.398v-1-1h8.806z","fill":"#FEFCF8"}));
}

BlogArrowInline.defaultProps = {"viewBox":"0 0 11 12","fill":"none"};

module.exports = BlogArrowInline;

BlogArrowInline.default = BlogArrowInline;
